<template>
  <div class="quarter">
    <!-- 弹窗显示后的遮罩层 -->
    <mark
      v-show="showSeason"
      style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;"
      @click.stop="showSeason=false"
    />
    <el-input
      v-model="showValueTow"
      placeholder="请选择季度"
      style="width:158px;"
      readonly
      @focus="showSeason=true"
    >
      <i slot="prefix" class="el-input__icon el-icon-date" />
    </el-input>
    <!-- 卡片弹窗 -->
    <el-card
      v-show="showSeason"
      :class="{'car-right':right}"
      style="width:322px;padding: 0 3px 20px;margin-top:10px;position:fixed;z-index:9999"
    >
      <div slot="header" style="text-align:center;padding:0">
        <button
          type="button"
          aria-label="前一年"
          class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
          @click="prev"
        />
        <span role="button" class="el-date-picker__header-label">{{ year }}年</span>
        <button
          type="button"
          aria-label="后一年"
          class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
          @click="next"
        />
      </div>
      <div class="quar-content">
        <div
          v-for="(item,index) in choseData"
          :key="index"
          style="width:50%"
          class="text-center"
        >
          <el-button
            type="text"
            :disabled="!isCanSelect(index)"
            :class="[(curPos===index && curChoseYear===year)?'choseQuarter':'']"
            @click="selectSeason(index)"
          >
            {{ item.name }}
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @author: v_zhuchun
 * @date: 2019-05-23
 * @description: UI组件  可选择季节
 */
import dayjs from 'dayjs';

export default {
  props: {
    // 默认的，传输过来的第几季度,选中的月份
    // defaultValue: {
    //   default: 1,
    //   type: Number,
    // },
    // 默认的，传输过来的年份,选中的年份
    // defaultYear: {
    //   default: dayjs().year(),
    //   type: Number,
    // },
    // 季度值
    showValue: {
      default: null,
      type: String,
    },
    // 限制,选择范围
    limit: {
      default: null,
      type: Object,
    },
    // 位置
    right: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showSeason: false, // 显示弹窗
      season: '',
      curPos: '', // 选中的季度（下标）
      year: dayjs().year(), // 标题的年份，选择的年份
      showValueTow: this.showValue, // input显示的值
      choseData: [{ // 季度按钮的遍历
        name: '第一季度(Q1)',
      }, {
        name: '第二季度(Q2)',
      }, {
        name: '第三季度(Q3)',
      }, {
        name: '第四季度(Q4)',
      }],
      curYear: dayjs().year(), // 今年
      curChoseYear: null, // 选中的年
    };
  },
  watch: {
    // defaultValue(value) {
    //   if (value) {
    //     const valuePos = Number(value) - 1; // 上次选中的季度（下标）
    //     this.year = this.defaultYear; // 标题的年份
    //     this.curChoseYear = this.defaultYear;// 当前选择的，上次选中的年
    //     this.curPos = valuePos; // 上次选中的季度（下标）
    //     this.showValue = `${this.year}-Q${this.defaultValue}`; // input 输入框显示
    //   } else {
    //     this.year = dayjs().year(); // 标题的年份
    //     this.curChoseYear = dayjs().year(); // 当前选择的，上次选中的年
    //     this.curPos = ''; // 上次选中的季度（下标）
    //     this.showValue = ''; // input 输入框显示
    //   }
    // },
  },
  // 数据传输完之后
  created() {
    // if (this.defaultValue && this.defaultYear) {
    //   const valuePos = Number(this.defaultValue) - 1;
    //   this.year = this.defaultYear;
    //   this.curChoseYear = this.defaultYear;// 当前选择的年
    //   this.curPos = valuePos;// 当前选择的季度
    //   this.showValue = `${this.year}-Q${this.defaultValue}`; // input 输入框显示
    // }
    // this.year = dayjs().year(); // 标题的年份
    // this.curChoseYear = dayjs().year(); // 当前选择的，上次选中的年
    // this.curPos = ''; // 上次选中的季度（下标）
    // this.showValue = ''; // input 输入框显示
    // this.selectSeason(0);
  },
  methods: {
    // 上一年
    prev() {
      this.year = this.year * 1 - 1;
    },
    // 下一年
    next() {
      this.year = this.year * 1 + 1;
    },
    // 是否能选择
    isCanSelect(index) {
      // 抄crm的需要优化
      if (!this.limit) { return true; }
      const {
        upLimitYear, upLimitQuarter, downLimitYear, downLimitQuarter,
      } = this.limit;
      const canYear = upLimitYear <= this.year && this.year <= downLimitYear;
      const sureQuarter = upLimitYear < this.year && this.year < downLimitYear;
      let canQuarter = false;
      if (this.year === upLimitYear) { canQuarter = (upLimitQuarter - 1) <= index; }
      if (this.year === downLimitYear) { canQuarter = (downLimitQuarter - 1) >= index; }
      return canYear && (sureQuarter || canQuarter);
    },
    // 选择季度
    selectSeason(pos) { // 参数：选中季度下标
      if (this.curPos === pos && this.curChoseYear === this.year) {
        return;
      }
      this.season = pos + 1;
      this.curPos = pos;
      this.curChoseYear = this.year;
      this.showSeason = false;
      this.showValueTow = `${this.year}-Q${this.season}`;
      this.$emit('selectQuarter', { value: this.showValueTow, year: this.year, quarterValue: this.season });
    },
    // 暂时无用
    cleanChoose() {
      this.showValueTow = '';
      this.curChoseYear = dayjs().year();
      this.curPos = '';
    },
  },
};
</script>
<style lang="less">
.quarter {
  display: inline-block;
  width: 158px;
  .car-right {
    right: 20px;
  }
  .quar-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    box-align: center;
    -moz-box-align: center;
    -webkit-box-align: center;
    box-sizing: border-box;
    .el-button--text {
      color: #606266;
      &:hover {
        color: #66b1ff;
      }
    }
    .el-button {
      &.is-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
        background-image: none;
        background-color: #FFF;
      }
      &.choseQuarter {
        color: #409EFF;
        font-weight:700;
      }
    }
  }
}

</style>
